<script setup lang="ts">
defineProps<{
  title: string;
}>();
</script>

<template>
  <h5 class="font-semibold">{{ title }}</h5>
</template>
